import React from "react"
import * as styles from "./Footer.module.css"

export default function Footer() {
    return (
        <footer className={styles.Footer}>Copyright © 2021 Tarek Ahmed</footer>
    )
}
